"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZATION_HEADER = exports.APPLICATION_ID_HEADER = void 0;
exports.APPLICATION_ID_HEADER = 'x-tr-applicationid';
exports.AUTHORIZATION_HEADER = 'Authorization';
